import { Injectable,ErrorHandler,Injector  } from '@angular/core';
import { Component, OnInit, ElementRef, ViewChild } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders ,} from '@angular/common/http';
import { Observable } from 'rxjs/Observable';

import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';
import { ErrorObservable } from 'rxjs/observable/ErrorObservable';
import { IbRequest } from './ib-request';
import { IbResponse } from './ib-response';
import {ActivatedRoute, Router} from "@angular/router";
@Injectable()
export class CallBackEndService {

 // private baseUrl: string = 'http://10.102.9.121:9095/InternetBankingTestServer/ib/ib-service/';
  // private heroku:String = 'https://cors-anywhere.herokuapp.com/';
  // private baseUrl: string = 'http://10.102.9.121:8092/';
          private baseUrl: string = '';//'http://10.102.9.121:8080/OnePageRoutinProj/'; 
 
  //  private baseUrl: string = 'http://10.102.9.121:9095/RoutingProj/';    //tomcat Deployment
  // private baseUrl: string = 'http://114.79.168.235:8091/';   //namrata's public port 
    
    

  //private baseUrl: string = 'http://114.79.162.173:8086/InternetBankingTestServer/ib/ib-service/';
 // private baseUrl = 'http://114.79.162.173:8093/InternetBankingTestServer/ib/ib-service/';
  //private baseUrl: string = 'http://10.101.10.58:8080/InternetBankingTestServer/ib/ib-service/';
 // private baseUrl: string = 'http://10.101.10.27:8080/InternetBankingWebServer/ib/ib-service/';
  private storedUserName: string = '';
  private token: string = '';
  private urlfromJson;

  private _jsonURL = 'assets/SampleUrl.json';
  bankName: any;

  constructor(private http: HttpClient,
              private router: Router,
              ) {
                this.getJSON().subscribe(data => {
                  console.log(' Sample Json Obj: '+JSON.stringify(data));
                  this.urlfromJson = data.param1;
                  this.bankName = data.bankName;
                  this.baseUrl=this.urlfromJson;
                 // console.log('urlfromJson----:-'+this.urlfromJson);
                 });        
  }
  public getJSON(): Observable<any> {
    return this.http.get(this._jsonURL);
  }



//   public getJSON(): Observable<any> {
//     return this.http.get("./baseUrlStore.json")
//                     .map((res:any) => res.json())
//                     ;
// }


  getResponse(request: IbRequest, url: string): Observable<IbResponse> {
    //request.param7=['Abhinav'];
    console.log("URL-"+this.baseUrl+url);
    console.log("request"+ JSON.stringify(request));
    this.storedUserName =sessionStorage.getItem('storedUserName');
    this.token =sessionStorage.getItem('token');
    console.log('storedUserName : ' + this.storedUserName + ', token : ' + this.token);  
    const httpPostOptions = {
      headers: new HttpHeaders(
        {
          // 'Content-Type': 'application/json',
          // 'Access-Control-Allow-Origin': '*',
          //   'Access-Control-Allow-Credentials': 'true',
          'Content-Security-Policy' : 'self'
        }),
      //withCredentials: true,
    };
    if (this.storedUserName === null) {
      return this.http.post<IbResponse>(this.baseUrl + url, request, httpPostOptions).map(response => {
        console.log(url + ' : ' + JSON.stringify(response));
        if (response.status === 'S101') {
          alert('Malicious Request Detected');
          return null;
        } else {
          return response;
        }
      }, error => {
        console.log(url + ' : ' + JSON.stringify(error));
        return error;
      }).catch(this.errorHandler);
    } else {
      console.log(this.token+' sdfd '+this.storedUserName+ 'sfsf' +this.baseUrl+'hfug');
      return this.http.post<IbResponse>(this.baseUrl + url + '?token=' + this.token + '&param=' + this.storedUserName, request, httpPostOptions).map(response => {
        console.log(url + ' : ' + JSON.stringify(response));
        if (response.status === 'S101') {
          alert('Malicious Request Detected');
          return null;
        } else {
          return response;
        }
      }, error => {
        console.log(url + ' : ' + JSON.stringify(error));
        return error;

      }).catch(this.errorHandler);
    }
  }

  getBankName(): Observable<string> {
    return this.bankName;
  }

  errorHandler(error: HttpErrorResponse): ErrorObservable {
    window.location.href='#/error';
    //this.router.navigate("/error");
    console.log('Error Occured--'+JSON.stringify(error));
    return Observable.throw(error.message || 'Server Error');
  }
}



// WEBPACK FOOTER //
// D:/Sonali/JCCBViewOnlyProject/ViewOnlyJCCBfrontend19112022/InternetBanking6.3frontend/src/app/call-back-end.service.ts